<fhlb-modal-2 id="beupdatesuccessmsg" [topBorder]="topBorderClass" class="" [showHeader]="false">
    <div class="modal-modalheight j">
        <div class="row justify-content-center text-center">
            <i class="fa fa-check-circle-o  fa-4x font-green" aria-hidden="true"></i>
        </div>
        <div class="row justify-content-center ">
            <div class="col-7 col-form-label message text-center " id="msg">
                {{message}}
            </div>
        </div>
        <div class="row justify-content-center">
            <button type="submit" class="btn col-7 btn-light-blue btn-primary" (click)="okClick()">
                <b>
                    OK
                </b>
            </button>
        </div>
    </div>
</fhlb-modal-2>